import React, { Component } from 'react'
import { connect } from 'react-redux'
import ActionCable from 'actioncable'
import { push } from 'react-router-redux'
import get from 'lodash/get'

import Notifications, { info, warning, error } from 'react-notification-system-redux'
import {
  incrementInProgressUnreadNotifications,
  incrementIssueUnreadNotifications
} from '../../actions/auth'

import { downloadReport } from '../../actions/reports'
import { loadServicingsForWorkOrder } from "../../actions/servicings";
import { fetchUnreadMessagesForWorkOrder } from "../../actions/messages";
import Echo from 'laravel-echo'

const UserType = Object.freeze({
  supervisor: "Supervisor",
  client: "Client",
  accountManager: "AccountManager",
  administrator: "Administrator",
})

const InProgressUserTypes = Object.freeze([UserType.supervisor, UserType.client, UserType.accountManager, UserType.administrator])
const DelayedNotificationsUserTypes = Object.freeze([UserType.supervisor, UserType.client, UserType.accountManager, UserType.administrator])
const IssueUserTypes = Object.freeze([UserType.supervisor, UserType.client, UserType.accountManager, UserType.administrator])
const UnsatisfactoryUserTypes = Object.freeze([UserType.supervisor, UserType.client, UserType.accountManager, UserType.administrator])

function mapStateToProps(state, ownProps) {
  const { session } = state.auth
  const { client, supervisor, accountManager } = UserType
  const desktopPreferences = get(state, 'settings.desktopPreferences', {})

  const {
    servicingCompletions: servicingCompletionNotifications = false,
    delayed: delayedNotifications = false,
    issues: issueNotifications = false,
    unsatisfactory: unsatisfactoryNotifications = false,
  } = desktopPreferences
  let token = ''
  let id = ''
  let locationIds = []
  let allowInProgressNotifications = false
  let allowIssueNotifications = false
  let allowDelayedNotifications = false
  let allowUnsatisfactoryNotifications = false

  if (session) {
    token = session.token
    id = session.id
    locationIds = session.locationIds
    allowInProgressNotifications = InProgressUserTypes.includes(session.type) && servicingCompletionNotifications
    allowDelayedNotifications = DelayedNotificationsUserTypes.includes(session.type) && delayedNotifications
    allowIssueNotifications = IssueUserTypes.includes(session.type) && issueNotifications
    allowUnsatisfactoryNotifications = UnsatisfactoryUserTypes.includes(session.type) && unsatisfactoryNotifications
  }

  return {
    token,
    id,
    locationIds,
    notifications: state.notifications,
    allowInProgressNotifications,
    allowIssueNotifications,
    allowDelayedNotifications,
    allowUnsatisfactoryNotifications,
  }
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onInProgressData(data, enabled) {
      let notificationOptions = {
        title: 'Servicing completed',
        message: data.message,
        position: 'tr',
        autoDismiss: 600,
        action: {
          label: 'View Work Order',
          callback: () => dispatch(push(`/in-progress/${data.work_order_id}`))
        }
      }

      switch (data.type) {
        case 'completed':
          if (!enabled) break
          dispatch(info(notificationOptions))
          dispatch(incrementInProgressUnreadNotifications())
          dispatch(loadServicingsForWorkOrder(data.work_order_id, 'unfinished'))
          dispatch(fetchUnreadMessagesForWorkOrder(data.work_order_id))
          break
        case 'delayed':
          if (!enabled) break
          const delayedNotificationOptions = {
            ...notificationOptions,
            title: 'Area Marked as Delayed',
            action: {
              label: 'View Area',
              callback: () => dispatch(push(`/work-orders/${data.work_order_id}/details/areas/${data.servicing_id}`))
            }
          }
          dispatch(info(delayedNotificationOptions))
          // dispatch(incrementDelayedUnreadNotifications())
          break
        case 'unsatisfactory':
          if (!enabled) break
          const unsatisfactoryNotificationOptions = {
            ...notificationOptions,
            title: 'Servicing Corrective Action'
          }
          dispatch(error(unsatisfactoryNotificationOptions))
      }
    },
    onIssueData(data, enabled) {
      let notificationOptions = {
        title: 'Issue created',
        message: data.message,
        position: 'tr',
        autoDismiss: 600,
        action: {
          label: 'View Issue',
          callback: () => dispatch(push(`/location-issues/${data.location_id}/issue/${data.issue_id}`))
        }
      }

      switch (data.type) {
        case 'created':
          if (!enabled) break
          dispatch(warning(notificationOptions))
          dispatch(incrementIssueUnreadNotifications())
      }
    },

    onDelayedData(data, enabled) {
      let notificationOptions = {
        title: 'Work Order Delayed',
        message: data.message,
        position: 'tr',
        autoDismiss: 600,
        action: {
          label: 'View Issue',
          callback: () => dispatch(push(`/work-orders/${data.work_order_id}/details/areas/${data.servicing_id}`))
        }
      }

      switch (data.type) {
        case 'delayed':
          if (!enabled) break
          dispatch(warning(notificationOptions))
      }
    },

    onReportData({ id, message }) {
      let notificationOptions = {
        title: 'Report Generated',
        message,
        position: 'tr',
        autoDismiss: 1500,
        action: {
          label: 'Download Report',
          callback: () => {
            dispatch(downloadReport(id))
          },
        }
      }

      dispatch(info(notificationOptions))
    }
  }
}

class NotificationsChannel extends Component {
  handleInProgressDataReceived(data) {
    const { allowInProgressNotifications, allowUnsatisfactoryNotifications, onInProgressData, allowDelayedNotifications } = this.props

    onInProgressData(data, data.type === 'completed' ? allowInProgressNotifications : (data.type === 'delayed') ? allowDelayedNotifications : allowUnsatisfactoryNotifications)
  }

  handleIssueDataReceived(data) {
    const { allowIssueNotifications, onIssueData } = this.props

    onIssueData(data, allowIssueNotifications)
  }

  handleReportGenerated(data) {
    const { onReportData } = this.props

    onReportData(data)
  }

  componentDidMount() {
    const { locationIds, token, id } = this.props

    // this.cable = ActionCable.createConsumer(`${process.env.ACTIONCABLE_URL}?token=${token}`)

    // this.inProgressSubscription = this.cable.subscriptions.create(
    //   { channel: 'ServicingChannel', user_id: id, location_ids: locationIds },
    //   { received: this.handleInProgressDataReceived.bind(this) }
    // )

    // this.issueSubscription = this.cable.subscriptions.create(
    //   { channel: 'IssueChannel', user_id: id, location_ids: locationIds },
    //   { received: this.handleIssueDataReceived.bind(this) }
    // )

    // this.reportSubscription = this.cable.subscriptions.create(
    //   { channel: 'ReportChannel', user_id: id },
    //   { received: this.handleReportGenerated.bind(this) }
    // )

    window.Pusher = require('pusher-js');

    window.Echo = new Echo({
      broadcaster: 'pusher',
      // key: process.env.MIX_PUSHER_APP_KEY,
      // cluster: process.env.MIX_PUSHER_APP_CLUSTER,
      key: process.env.PUSHER_APP_KEY,
      cluster: process.env.PUSHER_APP_CLUSTER,
      // encrypted: true,
      forceTLS: true,
      // encryption:true,
      authEndpoint: (process.env.API_ENDPOINT.replace('/api', '')) + '/broadcasting/token-auth',
      auth: {
        headers: {
          // Authorization: `Bearer ${token}`,
          "X-Auth-Token": token,
        },
      },
    });

    window.Echo.private("Notifications." + id)
      // .on('pusher:subscription_succeeded', () => {
      //   alert("success!");
      // })
      .listen("ServicingNotification", (e) => {
        this.handleInProgressDataReceived.bind(this)(e.data);
      })
      .listen("IssueNotification", (e) => {
        // this.handleIssueDataReceived.bind(this);
        // this.handleIssueDataReceived(e.data);
        this.handleIssueDataReceived.bind(this)(e.data);
      })
      .listen("ReportNotification", (e) => {
        this.handleReportGenerated.bind(this)(e.data);
      });

    // window.Echo.channel("Notifications." + id)
    //   .on('pusher:subscription_succeeded', () => {
    //     alert("success!");
    //   })
    //   .listen("IssueNotification", (e) => {
    //     alert(e.message);
    //   });
  }

  componentWillUnmount() {
    // this.inProgressSubscription.unsubscribe()
    // this.issueSubscription.unsubscribe()
    // this.reportSubscription.unsubscribe()

    // this.cable.disconnect()

    const { locationIds, token, id } = this.props

    window.Echo.private("Notifications." + id)
      .stopListening("ServicingNotification")
      .stopListening("IssueNotification")
      .stopListening("ReportNotification");

    window.Echo.leave("Notifications." + id);

    window.Echo.disconnect();
  }

  render() {
    const { notifications } = this.props
    const style = {
      NotificationItem: {
        info: {
          borderTop: '0px'
        }
      }
    }

    return (
      <Notifications
        notifications={notifications}
        style={style}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsChannel)



// WEBPACK FOOTER //
// ./src/components/notifications/notifications.js